import { RESET_STORE } from "../../store/constants/general";
import { Persist } from "../../config";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

import app from "./appReducer";
import database from "./databaseReducer";
import regions from "./regionsReducer";
import products from "./productsReducer";
import productVideos from "./productVideosReducer";
import sportTypes from "./sportTypesReducer";
import sportVariants from "./sportVariantsReducer";
import conditions from "./conditionsReducer";
import configurator from "./configuratorReducer";
import advisor from "./advisorReducer";
import wishlist from "./wishlistReducer";
import pushNotifications from "./pushNotificationsReducer";
import inAppNotifications from "./inAppNotificationsReducer";
import weatherProviders from "./weatherProvidersReducer";

const appReducer = combineReducers({
  app,
  database,
  regions,
  products,
  productVideos,
  sportTypes,
  sportVariants,
  conditions,
  configurator,
  advisor,
  wishlist,
  pushNotifications,
  inAppNotifications,
  weatherProviders
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    if (Persist.active) {
      console.log("Clearing Persisted storage...");
      Object.keys(state).forEach(key => {
        storage.removeItem(`persist:${key}`);
      });
    }

    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
